import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    standalone: false,
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {
    public subscriptionLink = environment.ACCOUNT_SUBSCRIPTIONS;

}
